import { constants } from "../service";

export const setProjectStore = data => ({
  type: constants.SET_PROJECT_STORE,
  data,
});

export const setProject = (data, isPublic, reCaptchaToken) => ({
  type: constants.SET_PROJECT,
  data,
  isPublic,
  reCaptchaToken,
});

export const setProjectSuccess = data => {
  return {
    type: constants.SET_PROJECT_SUCCESS,
    payload: data,
  };
};

export const setProjectError = error => ({
  type: constants.SET_PROJECT_ERROR,
  error,
});

export const getProject = id => ({
  type: constants.GET_PROJECT,
  id,
});

export const getProjectSuccess = data => ({
  type: constants.GET_PROJECT_SUCCESS,
  payload: data,
});

export const getProjectError = error => ({
  type: constants.GET_PROJECT_ERROR,
  error,
});

export const deleteProject = id => ({
  type: constants.DELETE_PROJECT,
  id,
});

export const deleteProjectSuccess = () => ({
  type: constants.DELETE_PROJECT_SUCCESS,
});

export const deleteProjectError = error => ({
  type: constants.DELETE_PROJECT_ERROR,
  error,
});

export const getAssociableCourses = id => ({
  type: constants.GET_ASSOCIABLE_COURSES,
  id,
});

export const getAssociableCoursesSuccess = data => ({
  type: constants.GET_ASSOCIABLE_COURSES_SUCCESS,
  payload: data,
});

export const getAssociableCoursesError = error => ({
  type: constants.GET_ASSOCIABLE_COURSES_ERROR,
  error,
});

export const getCourse = id => ({
  type: constants.GET_COURSE,
  id,
});

export const getCourseSuccess = data => ({
  type: constants.GET_COURSE_SUCCESS,
  payload: data,
});

export const getCourseError = error => ({
  type: constants.GET_COURSE_ERROR,
  error,
});

export const getAreas = () => ({
  type: constants.GET_AREAS,
});

export const getAreasSuccess = data => ({
  type: constants.GET_AREAS_SUCCESS,
  payload: data,
});

export const getAreasError = error => ({
  type: constants.GET_AREAS_ERROR,
  error,
});

export const getSoftwares = () => ({
  type: constants.GET_SOFTWARES,
});

export const getSoftwaresSuccess = data => ({
  type: constants.GET_SOFTWARES_SUCCESS,
  payload: data,
});

export const getSoftwaresError = error => ({
  type: constants.GET_SOFTWARES_ERROR,
  error,
});

export const setCreateContentItem = elementType => ({
  type: constants.CREATE_CONTENT_ITEM_STORE,
  elementType,
});

export const setRemoveContentItem = elementId => ({
  type: constants.REMOVE_CONTENT_ITEM_STORE,
  elementId,
});

export const setChangeContentItem = (elementId, key, value) => ({
  type: constants.CHANGE_CONTENT_ITEM_STORE,
  key,
  value,
  elementId,
});

export const setUpdateContentItemsPosition = contentItems => ({
  type: constants.UPDATE_CONTENT_ITEMS_POSITION_STORE,
  contentItems,
});

export const setReCaptchaVersion = reCaptchaVersion => ({
  type: constants.SET_RECAPTCHA_VERSION_STORE,
  reCaptchaVersion,
});

export const setImageStartLoading = () => ({
  type: constants.SET_IMAGE_START_LOADING,
});

export const setImageStopLoading = () => ({
  type: constants.SET_IMAGE_STOP_LOADING,
});

export const setCoverStartLoading = () => ({
  type: constants.SET_COVER_START_LOADING,
});

export const setCoverStopLoading = () => ({
  type: constants.SET_COVER_STOP_LOADING,
});

export const setEmbedStartLoading = () => ({
  type: constants.SET_EMBED_START_LOADING,
});

export const setEmbedStopLoading = () => ({
  type: constants.SET_EMBED_STOP_LOADING,
});
